import { MAX_PAGINATION_LIMIT } from '@ftr/annotations-contracts'
import { ApiResult, switchMapData } from '@ftr/foundation'

// limit to 10 calls x 100 records to prevent infinite loop in case of any issues
const MAX_REQUESTED_PAGES = 10

/** Recursively accumulates pages (via `fetchPage`) until all items have been collected. */
export function fetchAllPages<T>(
  fetchPage: (offset: number) => ApiResult<{ items: T[]; total: number }>,
  offset = 0,
  accumulated: T[] = [],
  requested = 0,
): ApiResult<T[]> {
  return fetchPage(offset).pipe(
    switchMapData(result => {
      const allItems = [...accumulated, ...result.items]
      if (allItems.length < result.total && requested < MAX_REQUESTED_PAGES) {
        return fetchAllPages(fetchPage, offset + MAX_PAGINATION_LIMIT, allItems, requested + 1)
      }
      return ApiResult.success(allItems)
    }),
  )
}
